import React, { useEffect, useRef } from 'react';
import '../index.css';
import HoursOfOperation from '../components/HoursOfOperation/HoursOfOperation';
import StoreAddress from '../components/StoreAddress/StoreAddress';
import { Link } from 'react-router-dom';
import ImageCarousel from '../components/ImageCarousel/ImageCarousel';
import { JOBS_URL, ORDER_ONLINE_URL } from '../constants';

const Home = () => {
  const parallaxRef = useRef(null);
  
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrollTop = window.pageYOffset;
        const parallaxElement = parallaxRef.current;
        const parallaxImage = parallaxRef.current.querySelector('.home-image');
        
        // Calculate if element is in viewport
        const rect = parallaxElement.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
        
        // Only apply parallax effect if element is visible
        if (isInViewport && parallaxImage) {
          // Adjust the divisor (3) to control the parallax intensity - smaller = more movement
          const offset = scrollTop / 2.5;
          parallaxImage.style.transform = `translateY(${offset}px)`;
        }
      }
    };
    
    // Initial check
    handleScroll();
    
    // Add event listener with throttling for better performance
    let ticking = false;
    const scrollListener = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', scrollListener);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, []);
  
  return (
    <>
      <div className="home-title-container" ref={parallaxRef}>
        <picture>
          <source 
            srcSet="/images/burger_barn_food_spread-480.jpg 1x, /images/burger_barn_food_spread-960.jpg 2x" 
            media="(max-width: 480px)" 
          />
          <source 
            srcSet="/images/burger_barn_food_spread-768.jpg 1x, /images/burger_barn_food_spread-1536.jpg 2x" 
            media="(max-width: 768px)" 
          />
          <source 
            srcSet="/images/burger_barn_food_spread-1200.jpg 1x, /images/burger_barn_food_spread-2400.jpg 2x" 
            media="(min-width: 769px)" 
          />
          <img 
            className="home-image"
            src="/images/burger_barn_food_spread-1200.jpg" 
            alt="Burger Barn's signature burgers, home-cut fries and shakes in Garden City, Utah" 
          />
          </picture>
      </div>
      <div className="home-text-section">
        <h1>Best burgers shakes and fries in Bear Lake</h1>
        <p>We serve high quality, Burgers, Shakes, Fries and More! From our signature home-cut fries, to our fresh, 
          never frozen, hand-pressed burger patties. The quality of our food is our priority! We also have a variety 
          of thick creamy shakes that are perfect for those hot summer days at Bear Lake!</p>
        <a
          className="cta-button-white"
          href={ORDER_ONLINE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Order Online
        </a>
        <Link to="/menu" className="cta-button-white">Menu</Link>
      </div>
      {/* TODO- WHERE DA MILKSHAKES!!!!!! <div className="text-section">
        <h3>BURGERS, FRIES,<br/>SHAKES, & MORE</h3>
      </div> */}
      <div className="main-content">
        <div className="carousel-section">
          <ImageCarousel />
        </div>
        {/* <div>
          IMAGES
        </div> */}
        <HoursOfOperation />
        <StoreAddress />
        <div className="call-to-action-buttons">
          <a 
            className="cta-button"
            href={JOBS_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
          >
            Join our team
          </a>
        </div>
      </div>
    </>
  );
};

export default Home;